export default __webpack_public_path__ + "static/media/deliveryguy.79b16829.png";